import React, { Component } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { localize } from '../../util/Localizer'
import RBButton from '../../controls/RBButton'
import { emptyClaimState, emptyClaimStateNoResults } from '../../assets/images'

import Isvg from 'react-inlinesvg'
import NgrxAuth from '../../auth/Auth'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { push } from 'connected-react-router'

class EmptyClaims extends Component {
  constructor (props) {
    super(props)
    this.submitClaim = this.submitClaim.bind(this)
  }

  submitClaim () {
    this.props.push('/SubmitAClaim')
  }

  clearButton () {
    let filtered = this.props.filteredEmptyState
    if (NgrxAuth.canSubmitClaim && filtered) {
      // user has claims and can submit
      return {
        label: localize('pages.claims.filter.clear'),
        func: this.props.clearFilters,
        hide: false
      }
    } else if (NgrxAuth.canSubmitClaim && !filtered) {
      // the user has no claims and can submit a claim
      return {
        label: localize('common.header.submitClaim'),
        func: this.submitClaim,
        hide: false
      }
    } else if (!NgrxAuth.canSubmitClaim && filtered && this.props.filterObj) {
      // user has claims but cannot submit another
      return {
        label: localize('pages.claims.filter.clear'),
        func: this.props.clearFilters,
        hide: false
      }
    } else {
      // user has no claims and cannot submit a claim
      return {
        label: '',
        func: null,
        hide: true
      }
    }
  }

  render () {
    let filtered = this.props.filteredEmptyState
    let button = this.clearButton()
    return (
      <div className='emptyStateClaimContainer'>
        <Row middle='xs' className='centered'>
          <Col>
            <Isvg className='emptyClaimState' src={filtered ? emptyClaimStateNoResults : emptyClaimState} />
            <p className='emptyStateText'>{filtered ? localize('pages.claims.emptyState.noResults') : localize('pages.claims.emptyState')}</p>
          </Col>
          <Col>
            { !button.hide
              ? <RBButton
                label={button.label}
                onClick={button.func}
                variant='contained'
                primary
              />
              : null }
          </Col>
        </Row>
      </div>
    )
  }
}
function mapStateToProps (state, ownProps) {
  return {
    user: state.user,
    filterObj: state.ClaimsReducer.filterObj
  }
}

const ConnectedEmptyClaims = connect(mapStateToProps, { push })(injectIntl(EmptyClaims))

export default ConnectedEmptyClaims



// WEBPACK FOOTER //
// ./src/widgets/Claims/EmptyClaimsState.js